<div
  class="plan-overview-fasting-chart-container"
  [ngStyle]="{ height: type === 'hourly' ? '336px' : '216px' }"
>
  <div class="plan-overview-fasting-chart-title" (click)="changeTab()">
    {{ title }}
    <img src="assets/plans/edit.svg" />
  </div>
  <div *ngIf="type === 'hourly'" class="plan-overview-fasting-chart-indicators">
    <div *ngIf="isFasting" class="plan-overview-fasting-chart-indicators-title">
      {{ duration }} ساعت فستینگ
      <div
        class="plan-overview-fasting-chart-indicators-color"
        style="background: #ffbc25"
      ></div>
    </div>
    <div *ngIf="!isFasting" class="plan-overview-fasting-chart-indicators-title">
      {{ 24 - duration }} ساعت فستینگ
      <div
        class="plan-overview-fasting-chart-indicators-color"
        style="background: #ffbc25"
      ></div>
    </div>
    <div *ngIf="isFasting" class="plan-overview-fasting-chart-indicators-title">
      {{ 24 - duration }} ساعت مجاز
      <div
        class="plan-overview-fasting-chart-indicators-color"
        style="background: #0073ff"
      ></div>
    </div>
    <div *ngIf="!isFasting" class="plan-overview-fasting-chart-indicators-title">
      {{ duration }} ساعت مجاز
      <div
        class="plan-overview-fasting-chart-indicators-color"
        style="background: #0073ff"
      ></div>
    </div>
  </div>

  <div
    *ngIf="type === 'daily'"
    class="plan-overview-fasting-chart-indicators"
    style="width: 90px"
  >
    <div class="plan-overview-fasting-chart-indicators-title">
      {{ duration }} روز فستینگ
      <div
        class="plan-overview-fasting-chart-indicators-color"
        style="background: #ffbc25"
      ></div>
    </div>
    <div class="plan-overview-fasting-chart-indicators-title">
      {{ 7 - duration }} روز عادی
      <div
        class="plan-overview-fasting-chart-indicators-color"
        style="background: #0073ff"
      ></div>
    </div>
  </div>

  <div *ngIf="type === 'hourly'" class="plan-overview-fasting-chart-holder">
    <div class="plan-overview-fasting-chart-background"></div>
    <div style="position: relative">
      <canvas
        baseChart
        id="canvas"
        [data]="demodoughnutChartData1"
        [labels]="doughnutChartLabels"
        [colors]="chartColors1"
        height="190"
        width="190"
        [chartType]="doughnutChartType"
        [options]="options"
        id="canvass"
      >
      </canvas>
      <canvas
        baseChart
        id="canvas"
        [data]="demodoughnutChartData2"
        [labels]="doughnutChartLabels"
        [colors]="chartColors2"
        height="174"
        width="174"
        [chartType]="doughnutChartType"
        [options]="options"
        id="canvass"
        style="position: absolute; top: 8px; right: 8px"
      >
      </canvas>
      <img *ngIf="isFasting" src="assets/plan/chartIndicator.svg" />
      <div class="plan-overview-fasting-chart-time-title">زمان سپری شده</div>
      <div class="plan-overview-fasting-chart-time">{{ spentTime }}</div>
      <div class="plan-overview-fasting-chart-line"></div>
      <div *ngIf="isFasting" class="plan-overview-fasting-chart-percentage">
        {{ percentage }} %
      </div>
      <div
        *ngIf="!isFasting"
        class="plan-overview-fasting-chart-next-fasting-title"
      >
        شروع فستینگ بعدی
      </div>
      <div *ngIf="!isFasting" class="plan-overview-fasting-chart-next-fasting">
        {{ startTimeTitle2 }}
      </div>
    </div>
  </div>
  <div *ngIf="type === 'hourly'" class="plan-overview-fasting-chart-fake"></div>
  <div *ngIf="type === 'hourly'" class="plan-overview-fasting-chart-bot-holder">
    <div class="plan-overview-fasting-chart-bot-indicator1">
      <div class="plan-overview-fasting-chart-bot-inner-indicator1"></div>
    </div>
    <div class="plan-overview-fasting-chart-bot-line"></div>
    <div class="plan-overview-fasting-chart-bot-indicator2">
      <div class="plan-overview-fasting-chart-bot-inner-indicator2"></div>
    </div>
    <div class="plan-overview-fasting-chart-bot-title" style="top: 0">
      شروع فستینگ
    </div>
    <div class="plan-overview-fasting-chart-bot-title" style="top: 41px">
      پایان فستینگ
    </div>
    <div
      class="plan-overview-fasting-chart-bot-time-title-holder"
      (click)="editFastingStartTime()"
    >
      <div
        class="plan-overview-fasting-chart-bot-time-title normal-color"
        style="top: 0"
      >
        {{ startTimeTitle }}
      </div>
      <img src="assets/plans/edit-blue.svg" />
    </div>
    <div class="plan-overview-fasting-chart-bot-time-title" style="top: 41px">
      {{ endTimeTitle }}
    </div>
  </div>

  <div
    *ngIf="type === 'daily'"
    class="plan-overview-fasting-chart-daily-holder"
  >
    <div class="plan-overview-fasting-chart-daily-days-holder">
      <div
        *ngFor="let day of days; let i = index; let last = last"
        class="plan-overview-fasting-chart-daily-day-holder"
      >
        <div
          *ngIf="!isBeforeStart[i] && dayOfWeek >= i + 1"
          class="plan-overview-fasting-chart-daily-day-background"
          [ngStyle]="{
            'border-radius': dayOfWeek > i + 1 ? '0' : '100px 0px 0px 100px'
          }"
        ></div>
        <div
          *ngIf="dayOfWeek === i + 1"
          class="plan-overview-fasting-chart-daily-day-today"
        ></div>
        <div class="plan-overview-fasting-chart-daily-day">
          {{ day }}
        </div>
        <div
          [ngClass]="
            fastingDays.includes(i + 1)
              ? 'plan-overview-fasting-chart-daily-day-bottom-border fasting'
              : 'plan-overview-fasting-chart-daily-day-bottom-border normal'
          "
        ></div>
        <div
          *ngIf="
            !last && fastingDays.includes(i + 1) === fastingDays.includes(i + 2)
          "
          [ngClass]="
            fastingDays.includes(i + 1)
              ? 'plan-overview-fasting-chart-daily-day-bottom-border-joint fasting'
              : 'plan-overview-fasting-chart-daily-day-bottom-border-joint normal'
          "
        ></div>
      </div>
    </div>
  </div>
</div>
